import moment from "moment";

export const getStartTimeForTimePicker = (selectedDate: any, interval: number = 15) => {
    if (!selectedDate) return null;
    const selected = moment(selectedDate, "MM/DD/YYYY");
    const today = moment().startOf("day");
    // Condition so that user cannot set previous time in the day
    // If selected date is today → minTime = current time (HH:mm)
    // Otherwise (future date) → allow all times
    if (selected.isSame(today, "day")) {
        return roundTimeToNextInterval(moment(), interval).format("hh:mm A");
    } else {
        return null;
    }
};

export const roundTimeToNextInterval = (time: moment.Moment, interval: number = 15) => {
    const remainder = time.minutes() % interval;
    let roundedMinutes = remainder === 0 ? time.minutes() : time.minutes() + (interval - remainder);
    if (roundedMinutes === 60) time.add(1, "hour").minutes(0);
    else time.minutes(roundedMinutes);
    return time;
};

export const isToday = (date: string) => {
    return moment(date, "MM/DD/YYYY", true).isSame(moment(), "day");
};

export const formatTime = (value: moment.Moment) => {
    return value.format("hh:mm A");
};
